var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex_gap_10" },
    [
      _vm.shiftMessage
        ? _c(
            "div",
            [
              _vm.shiftMessage.message_type === "timeRemain"
                ? [
                    _c("VueCountdown", {
                      attrs: { time: _vm.shiftMessage.value * 60 * 1000 },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _vm._v("Окончание смены через： "),
                                _c(
                                  "span",
                                  { staticClass: "badge badge-info" },
                                  [_vm._v(_vm._s(props.minutes))]
                                ),
                                _vm._v("\n          мин.\n        "),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4272786841
                      ),
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.shiftMessage.message_type === "shiftOverdue"
                ? [_vm._m(0)]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$myShift
        ? [
            !_vm.$AllowedShifts || !_vm.$AllowedShifts.length
              ? [_vm._m(1)]
              : [
                  _c(
                    "v-popover",
                    {
                      attrs: {
                        trigger: "click",
                        open: _vm.openPopover,
                        popoverClass: "list_work_shift_activation_popover",
                        popoverInnerClass: "popover_content",
                        "auto-hide": false,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "no_shift_icon_block badge badge-warning",
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-info" })]
                      ),
                      _vm._v(" "),
                      _c("template", { slot: "popover" }, [
                        _c(
                          "div",
                          {},
                          [
                            _vm.$UserIsFreeToday
                              ? [
                                  _c("p", [
                                    _vm._v(
                                      "По графику Вы сегодня не работаете"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Желаете активировать смену или выбрать менеджера для подмены?"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v("Выберите кого хотите подменить"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mb-1" },
                                    [
                                      _c("Multiselect", {
                                        attrs: {
                                          options: _vm.usersToShift,
                                          placeholder: "Выберите менеджера",
                                          label: "name",
                                          "track-by": "name",
                                        },
                                        model: {
                                          value: _vm.userToShift,
                                          callback: function ($$v) {
                                            _vm.userToShift = $$v
                                          },
                                          expression: "userToShift",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : [_c("p", [_vm._v("Выберите смену")])],
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex_gap_10" }, [
                              _c(
                                "div",
                                _vm._l(_vm.$AllowedShifts, function (shift) {
                                  return _c(
                                    "div",
                                    { staticClass: "mb-1" },
                                    [
                                      _c("LoadingButton", {
                                        attrs: {
                                          title:
                                            shift?.title +
                                            ` (${_vm.printTime(
                                              shift?.start,
                                              "HH:mm"
                                            )} - ${_vm.printTime(
                                              shift?.end,
                                              "HH:mm"
                                            )})`,
                                          className: "btn btn-default",
                                          loading: _vm.loading,
                                          color: "#02a2f8",
                                          onClick: () =>
                                            _vm.activateShift(shift),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                            ]),
                          ],
                          2
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
          ]
        : [
            _c(
              "div",
              { staticClass: "flex flex_gap_10" },
              [
                _c(
                  "div",
                  { staticClass: "fs-12" },
                  [
                    _c("p", [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$ActiveWorkGroup?.group?.title)),
                      ]),
                    ]),
                    _vm._v(" "),
                    (_vm.$ActiveWorkGroup?.group?.data?.projects ?? []).length
                      ? [
                          _c(
                            "p",
                            _vm._l(
                              _vm.$ActiveWorkGroup.group.data.projects,
                              function (p, i) {
                                return _c("span", [
                                  _vm._v(
                                    _vm._s(i !== 0 ? ", " : "") +
                                      _vm._s(_vm.$AllProjects[p]?.title)
                                  ),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      : [_c("p", [_vm._v("все проекты")])],
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$myShift?.shift?.title) +
                          " (" +
                          _vm._s(_vm.$myShift?.shift?.id) +
                          ")"
                      ),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "v-popover",
                  {
                    attrs: {
                      delay: { show: 100, hide: 500 },
                      popoverClass: "work_shift_activation_popover",
                      popoverInnerClass: "popover_content",
                      trigger: "hover",
                      "auto-hide": true,
                    },
                  },
                  [
                    _c("div", { staticClass: "popover_icon" }, [
                      _c("i", { staticClass: "icon-fa icon-fa-info" }),
                    ]),
                    _vm._v(" "),
                    _c("template", { slot: "popover" }, [
                      _c("div", {}, [
                        _c("p", [
                          _vm._v("Активировна с: "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.printDate(
                                  _vm.activeShift.created_at,
                                  "HH:mm"
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$myShift?.shift?.title) +
                                " (" +
                                _vm._s(_vm.$myShift?.shift?.id) +
                                ")"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.$myShift?.shift
                          ? _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.printTime(_vm.$myShift?.shift?.start)
                                ) +
                                  " - " +
                                  _vm._s(
                                    _vm.printTime(_vm.$myShift?.shift?.end)
                                  )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", [_vm._v("Мои доступы")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          _vm._l(_vm.$orderAccess, function (access, project) {
                            return _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    project === "all"
                                      ? "Все проекты"
                                      : (_vm.$AllProjects[project] &&
                                          _vm.$AllProjects[project].name) ||
                                          "Не определен"
                                  )
                                ),
                              ]),
                              _vm._v(
                                ":\n                " +
                                  _vm._s(
                                    access.all
                                      ? "Все направления"
                                      : (_vm.$AllCities[
                                          Object.keys(access)[0]
                                        ] &&
                                          _vm.$AllCities[Object.keys(access)[0]]
                                            .name) ||
                                          "не определен"
                                  ) +
                                  "\n              "
                              ),
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("Активные "),
                          _c("strong", [_vm._v("SIP")]),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          _vm._l(_vm.$PhoneNumbers.sipAccounts, function (sip) {
                            return _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex_gap_10 justify-content-between mb-1",
                              },
                              [
                                _c("p", [
                                  _vm._v(_vm._s(_vm.printSip(sip.sip_login))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-outline-info btn-xs mr-1",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyToBuffer(
                                            sip.sip_login,
                                            true
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-copy",
                                      }),
                                      _vm._v(" SIP\n                  "),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-outline-info btn-xs",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyToBuffer(
                                            sip.sip_password
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-copy",
                                      }),
                                      _vm._v(" пароль\n                  "),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-warning",
                              on: { click: _vm.closeShift },
                            },
                            [_vm._v("Закрыть смену")]
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "flex flex_gap_10 close_shift_message border" },
      [
        _c(
          "div",
          {
            staticClass:
              "flex badge badge-warning align-items-center no_shifts",
          },
          [_c("i", { staticClass: "icon-fa icon-fa-info fs-18" })]
        ),
        _vm._v(" "),
        _c("div", [
          _c("p", [_vm._v("Ваша смена закончена")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("будет закрыта автоматически в течении 15-ти минут"),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex flex_gap_10" }, [
      _c("div", [_c("p", [_vm._v("нет активных смен для Вас")])]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex badge badge-warning align-items-center no_shifts",
        },
        [_c("i", { staticClass: "icon-fa icon-fa-info fs-18" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }